import CheckboxOutlinedIcon from './CheckboxOutlinedIcon'

export default CheckboxOutlinedIcon
